/* eslint-disable */
<template>
	<section>
		<div class="maintenance-heading">Wartungsarbeiten</div>
	</section>
</template>
<script>
export default {
	name: 'Maintenance',

	components: {},
	computed: {
		booking () {
			return this.$store.state.booking
		}
	},

	data () {
		return {}
	},

	created () {
		// this.fetchData();
	},

	methods: {
		fetchData () {}
	}
}
</script>
<style >
.maintenance-heading {
	font-size: 3em;
	font-weight: bold;
	text-align: center;
	margin-top: 43vh;
	color: #d63031;
}
</style>



// WEBPACK FOOTER //
// src/components/Maintenance.vue